import React, { useContext } from 'react'
import { Route, Routes, useRoutes, Navigate } from 'react-router-dom'
import SubscriptionGate from './components/Subscriptions/SubscriptionGate'
import SystemRoutes from './routes/SystemRoutes'
import CrewVaultRoutes from './routes/CrewVaultRoutes'
import CommandControlRoutes from './routes/CommandControlRoutes'
import ConfigRoutes from './routes/ConfigRoutes'
import EventRoutes from './routes/EventRoutes'
import FinanceRoutes from './routes/FinanceRoutes'
import ShiftRoutes from './routes/ShiftRoutes'
import EmployeeRoutes from './routes/EmployeeRoutes'
import FleetEquipmentRoutes from './routes/FleetEquipmentRoutes'
import TrainingRoutes from './training/routes/TrainingRoutes'
import AuditLogPage from './pages/governance/audits/AuditLog'
import GovernanceRoutes from './routes/GovernanceRoutes'
import CQCCentreRoutes from './routes/CQCCentreRoutes'
import CustomerRoutes from './routes/CustomerRoutes'
import PatientRecordRoutes from './routes/PatientRecordRoutes'
import UserRoutes from './routes/UserRoutes'
import PatientTransportRoutes from './routes/PatientTransportRoutes'
import BaseLocationRoutes from './routes/BaseLocationRoutes'
import WallboardRoutes from './routes/WallboardRoutes'

export const routes = [
  ...SystemRoutes,
  ...CrewVaultRoutes,
  ...CommandControlRoutes,
  ...ConfigRoutes,
  ...EventRoutes,
  ...EmployeeRoutes,
  ...FleetEquipmentRoutes,
  ...GovernanceRoutes,
  ...CQCCentreRoutes,
  ...CustomerRoutes,
  ...PatientRecordRoutes,
  ...UserRoutes,
  ...ShiftRoutes,
  ...FinanceRoutes,
  ...TrainingRoutes,
  ...PatientTransportRoutes,
  ...BaseLocationRoutes,
  ...WallboardRoutes,
]

const SiteRoutes = () => useRoutes(routes)

export default SiteRoutes
